import type { ChatGeometry } from "@app/store/chat/ChatState";

import clampChatGeometry from "./clampChatGeometry";
import { CHAT_DEFAULT_HEIGHT, CHAT_DEFAULT_WIDTH } from "./consts";
import getChatArea from "./getChatArea";

/**
 * Where the window sits before the user has moved or resized it: default size, tucked
 * into the bottom-right corner of the allowed area — the same corner the collapsed
 * launcher occupies, so opening the chat grows it out of the button it replaces.
 *
 * Viewport-dependent, which is why it is a function rather than a constant, and why
 * chatSettings persists no default: storage cannot measure the viewport. Clamped so a
 * viewport too small for the default size still yields a legal rect.
 */
const getChatDefaultGeometry = (viewportWidth: number, viewportHeight: number): ChatGeometry => {
  const area = getChatArea(viewportWidth, viewportHeight);

  return clampChatGeometry(
    {
      height: CHAT_DEFAULT_HEIGHT,
      left: area.right - CHAT_DEFAULT_WIDTH,
      top: area.bottom - CHAT_DEFAULT_HEIGHT,
      width: CHAT_DEFAULT_WIDTH,
    },
    viewportWidth,
    viewportHeight
  );
};

export default getChatDefaultGeometry;
